<template>
  <div>
    <bread-crumb></bread-crumb>
    <man-form-list
      :select="select"
      :selectList="selectList"
      @getChangeValue="getChangeValue"
      @empty="empty"
      :num="num"
      :isBtn="isBtn"
      @write_remoteMethod="write_remoteMethod"
      @editorial_remoteMethod="editorial_remoteMethod"
    ></man-form-list>
    <div class="wiki-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          v-for="(item, index) in jbbkTabList"
          :key="index"
        >
          <span slot="label" class="slot-item">
            <span>{{ item.title }}</span
            ><span>{{ item.count }}</span>
          </span>
          <div class="base-table">
            <div class="base-table-table">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="contentId" label="药品ID">
                </el-table-column>
                <el-table-column prop="contentName" label="药品通用名">
                </el-table-column>
                <el-table-column label="上传人">
                  <template
                    slot-scope="scope"
                    v-if="scope.row.authors && scope.row.authors.length > 0"
                  >
                    <span>{{ scope.row.authors[0].nickName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="上传时间">
                </el-table-column>
                <el-table-column label="审核时间">
                  <template slot-scope="scope">
                    {{ scope.row.auditInfo.auditTime }}
                  </template>
                </el-table-column>
                <el-table-column prop="contentId" label="审核人">
                  <template slot-scope="scope">
                    {{ scope.row.auditInfo.auditUser }}
                  </template>
                </el-table-column>
                <el-table-column prop="contentId" label="审核状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.auditInfo.remark"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.auditInfo.auditStatus == 4"
                    >
                      <div
                        :class="
                          scope.row.auditInfo.auditStatus == 4 ? 'rejected' : ''
                        "
                      >
                        {{ scope.row.auditInfo.auditStatus | auditStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else>
                      {{ scope.row.auditInfo.auditStatus | auditStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="contentId" label="文章状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="reasonForOffline"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.contentStatus == 2"
                    >
                      <div
                        :class="scope.row.contentStatus == 2 ? 'rejected' : ''"
                        @mouseenter="remarkContent(scope)"
                      >
                        {{ scope.row.contentStatus | contentStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else>
                      {{ scope.row.contentStatus | contentStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="contentId" label="编审药师">
                  <template
                    slot-scope="scope"
                    v-if="
                      scope.row.doctorInfos && scope.row.doctorInfos.length > 0
                    "
                  >
                    <span
                      v-for="(item, index) in scope.row.doctorInfos"
                      :key="index"
                    >
                      <span v-if="item.roleType == 2">
                        {{
                          item.docName +
                          " " +
                          item.titleName +
                          " " +
                          "ID: " +
                          item.docId +
                          " " +
                          item.departName +
                          " " +
                          item.hospitalGradeName +
                          " " +
                          item.hospitalName
                        }}
                      </span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        type="text"
                        size="small"
                        v-if="scope.row.auditInfo.auditStatus == 2"
                        @click="toAuditPage(scope.row)"
                        >审核
                      </el-button>
                      <span
                        class="border"
                        v-if="
                          scope.row.auditInfo.auditStatus == 2 &&
                          scope.row.contentStatus == 1
                        "
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        v-if="
                          scope.row.auditInfo.auditStatus == 1
                            ? false
                            : scope.row.auditInfo.auditStatus == 2
                            ? false
                            : true
                        "
                        @click="toEditPage(scope.row)"
                        >编辑
                      </el-button>
                      <el-button
                        type="text"
                        size="small"
                        v-if="
                          scope.row.auditInfo.auditStatus == 1 &&
                          scope.row.contentStatus == 2
                        "
                        @click="toEditPage(scope.row)"
                        >编辑
                      </el-button>
                      <span
                        class="border"
                        v-if="
                          scope.row.contentStatus == 1 &&
                          scope.row.auditInfo.auditStatus !== 2 &&
                          scope.row.auditInfo.auditStatus !== 1
                        "
                      ></span>
                      <el-button
                        @click="articlePreview(scope.row)"
                        type="text"
                        size="small"
                        v-if="scope.row.contentStatus == 1"
                        >查看线上
                      </el-button>
                      <span
                        class="border"
                        v-if="scope.row.contentStatus == 1"
                      ></span>
                      <el-button
                        type="text"
                        size="small"
                        v-if="scope.row.contentStatus == 1"
                        @click="offlineDisease(scope.row)"
                        >下线
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <modal
      :isShow.sync="offlineDialog"
      title="下线"
      :width="width"
      :isShowBtn="isShowBtn"
      :btnText="ordinaryBtnText"
      @clickHandler="offlineClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px">
        <span class="red">*</span>
        <el-form-item label="下线理由" class="freezeDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入下线理由，不超过200字"
            v-model="offLineReasons"
            maxlength="200"
            show-word-limit
            class="freezeInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
import ManFormList from "../../../components/manFormList.vue";
import BreadCrumb from "../../../../../components/breadCrumb";
import pagination from "../../../../../components/pagination";
import modal from "../../../../../components/modal";
import {
  getDiseaseSymptoms,
  getDoctorInformation,
  getReviewStatus,
  changgeDiseaseSymptomsOnline,
} from "../../../../../api/symptomaticDisease";
const baseUrl = process.env.VUE_APP_BASEURL;

export default {
  name: "encyclopediaMan",
  components: { BreadCrumb, ManFormList, pagination, modal },
  data() {
    return {
      width: "400px",
      num: 1,
      isBtn: 1,
      activeName: "all",
      tableData: [],
      offlineDialog: false,
      isShowBtn: [true, true, false],
      ordinaryBtnText: ["取消", "确认"],
      offLineReasons: "",
      reasonForOffline: "",
      jbbkTabList: [
        {
          name: "all",
          title: "全部",
          count: 0,
          type: "allCount",
        },
        {
          name: "unaudit",
          title: "待审核",
          count: 0,
          type: "unAuditCount",
        },
        {
          name: "approved",
          title: "审核通过",
          count: 0,
          type: "passAuditCount",
        },
        {
          name: "rejected",
          title: "已驳回",
          count: 0,
          type: "rejectCount",
        },
      ],
      selectList: {
        drugID: "", // 药品ID
        genericNameOfDrug: "", // 药品通用名
        writeDoc: "", // 编写医生
        editorialDoctor: "", // 编审医生
        submissionTime: [], // 上传时间
        contentStatus: "", // 上传状态
      },
      select: [
        {
          prop: "drugID",
          type: "input2",
          placeholder: "请输入药品ID",
        },
        {
          prop: "genericNameOfDrug",
          type: "input",
          placeholder: "请输入药品通用名",
          maxLenth: 50,
        },
        {
          prop: "writeDoc",
          type: "selectBus",
          placeholder: "请输入编写医生",
          List: [],
        },
        {
          prop: "editorialDoctor",
          type: "editorialDoctor",
          placeholder: "请输入编审药师",
          List: [],
        },
        {
          prop: "submissionTime",
          type: "picker",
          placeholder: "请选择上传时间",
        },
        {
          prop: "contentStatus",
          type: "select",
          placeholder: "请选择上传状态",
          List: [
            {
              label: "全部",
              value: "",
            },
            {
              label: "已上线",
              value: 1,
            },
            {
              label: "已下线",
              value: 2,
            },
          ],
        },
      ],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      contentAuditStatusList: [1, 2, 3, 4],
      articleListCode: 0,
      baseUrl,
    };
  },
  filters: {
    auditStatus: function (data) {
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "审核通过";
        case 4:
          return "已驳回";
      }
    },
    contentStatus: function (data) {
      switch (data) {
        case 1:
          return "已上线";
        case 2:
          return "已下线";
        default:
          return "";
      }
    },
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("encyclopedia");
  },
  created() {
    this.initializeJump();
    this.pageDiseaseInfoDraftList();
    this.getDiseaseDraftCountList();
  },
  methods: {
    initializeJump() {
      if (sessionStorage.getItem("encyclopedia")) {
        let contentStatus = sessionStorage.getItem("encyclopediaStatus");
        this.paginationDataProduct.currentPage =
          sessionStorage.getItem("encyclopediaPage");
        this.selectList = JSON.parse(
          sessionStorage.getItem("encyclopediaList")
        );
        this.select = JSON.parse(sessionStorage.getItem("encyclopediaSelect"));
        this.activeName = sessionStorage.getItem("encyclopediaName");
        if (contentStatus == "1,2,3,4") {
          this.contentAuditStatusList = [1, 2, 3, 4];
        } else {
          this.contentAuditStatusList = [contentStatus];
        }
      } else {
        let encyclopediaObj = {
          contentName: "", // 药品名称
          aliasName: "", // 别名
          contentDiseases: [], //绑定疾病id
          keywordInfos: [], // 内容关键词
          doctorInfos: [], // 关联的医生
          contentDrugs: [], // 药品
          contentParagraphs: [], // 段落
          contentAttributes: [], // 常见药品
        };
        this.paginationDataProduct.currentPage = 1;
        this.selectList = encyclopediaObj;
      }
    },
    handleClick(tab) {
      if (tab.name == "all") {
        this.articleListCode = 0;
      } else if (tab.name === "unaudit") {
        this.articleListCode = 2;
      } else if (tab.name === "approved") {
        this.articleListCode = 3;
      } else if (tab.name === "rejected") {
        this.articleListCode = 4;
      }
      if (this.articleListCode !== 0) {
        this.contentAuditStatusList.splice(
          0,
          this.contentAuditStatusList.length
        );
        this.contentAuditStatusList.push(this.articleListCode);
      } else {
        this.contentAuditStatusList = [1, 2, 3, 4];
      }
      this.pageDiseaseInfoDraftList("1");
      this.getDiseaseDraftCountList();
    },
    getChangeValue(data) {
      if (this.$utils.checkNumber(data.drugID)) {
        this.pageDiseaseInfoDraftList("1");
        this.getDiseaseDraftCountList();
      } else {
        this.$message({
          message: "ID只能为数字",
          type: "warning",
        });
      }
    },
    empty() {
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.select.map((item) => {
        if (item.prop == "writeDoc") {
          item.List = [];
        }
        if (item.prop == "editorialDoctor") {
          item.List = [];
        }
      });
      this.pageDiseaseInfoDraftList();
      this.getDiseaseDraftCountList();
    },
    editorial_remoteMethod(val) {
      getDoctorInformation({
        tenantId: this.$commonJs.getTenantId(),
        doctorName: val,
      })
        .then((res) => {
          let arr = res.map((itemRes) => {
            return {
              value: itemRes.docId,
              label:
                itemRes.docName +
                " " +
                itemRes.titleName +
                " " +
                itemRes.hospitalGradeName +
                " " +
                itemRes.hospitalName +
                " " +
                itemRes.departName,
            };
          });
          this.select.map((item) => {
            if (item.prop == "editorialDoctor") {
              item.List.splice(0, item.List.length);
              item.List = arr;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    write_remoteMethod(val) {
      getDoctorInformation({
        tenantId: this.$commonJs.getTenantId(),
        doctorName: val,
      })
        .then((res) => {
          let arr = res.map((itemRes) => {
            return {
              value: itemRes.docId,
              label:
                itemRes.docName +
                " " +
                itemRes.titleName +
                " " +
                itemRes.hospitalGradeName +
                " " +
                itemRes.hospitalName +
                " " +
                itemRes.departName,
            };
          });
          this.select.map((item) => {
            if (item.prop == "writeDoc") {
              item.List.splice(0, item.List.length);
              item.List = arr;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageDiseaseInfoDraftList();
    },
    getParams() {
      let contentDoctorBizParams = [];
      if (this.selectList.writeDoc) {
        contentDoctorBizParams.push({
          docId: this.selectList.writeDoc,
          roleType: 1,
        });
      }
      if (this.selectList.editorialDoctor) {
        contentDoctorBizParams.push({
          docId: this.selectList.editorialDoctor,
          roleType: 2,
        });
      }
      let params;
      return (params = {
        contentType: 13,
        contentDoctorBizParams: contentDoctorBizParams || [],
        contentId: this.selectList.drugID || null,
        aliasNamePrecise: this.selectList.genericNameOfDrug || null,
        contentStatus: this.selectList.contentStatus
          ? [this.selectList.contentStatus]
          : [],
        tenantId: this.$commonJs.getTenantId(),
        docId: this.selectList.writeDoc || null,
        startTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[0]) ||
          null,
        endTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[1]) ||
          null,
        auditStatus: [1, 2, 3, 4],
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      });
    },
    // 获取各种状态的数量
    getDiseaseDraftCountList() {
      let params = this.getParams();
      getReviewStatus(params).then((res) => {
        this.jbbkTabList.forEach((item) => {
          item.count = res[item.type];
        });
      });
    },
    // 获取列表数据
    pageDiseaseInfoDraftList(val) {
      if (val == "1") {
        this.paginationDataProduct.currentPage = 1;
      }
      var patrn = /[0-9]/im;
      if (this.selectList.drugID && !patrn.test(this.selectList.drugID)) {
        return this.$message.error("请填写正确的ID");
      }
      let params = this.getParams();
      params.auditStatus = this.contentAuditStatusList;
      getDiseaseSymptoms(params).then((res) => {
        this.tableData = res.data;
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
      });
    },
    // 跳转审核页
    toAuditPage(data) {
      this.$router.push({
        path: "/wikiManage/encyclopediaEdit",
        query: {
          id: data.contentId,
          contentType: 1,
          articleType: data.contentType,
        },
      });
      this.setStorage();
    },
    // 跳转编辑页
    toEditPage(data) {
      this.$router.push({
        path: "/wikiManage/encyclopediaEdit",
        query: {
          id: data.contentId,
          contentType: 1,
          actionType: 1,
          articleType: data.contentType,
        },
      });
      this.setStorage();
    },
    // 下线文章
    offlineDisease(data) {
      this.offLineReasons = "";
      this.offlineDialog = true;
      this.getOffLineInfo(data);
    },
    getOffLineInfo(data) {
      this.offLineInfo = data;
    },
    // 下线
    offlineClickHandler(type) {
      if (type == "one") {
        this.offlineDialog = false;
      } else if (type == "two") {
        if (this.offLineReasons === "") {
          this.$message.error("请输入下线理由");
          return;
        }
        changgeDiseaseSymptomsOnline({
          contentId: this.offLineInfo.contentId,
          tenantId: this.$commonJs.getTenantId(),
          contentStatus: 2,
          remark: this.offLineReasons,
        }).then((res) => {
          this.$message.success("下线成功");
          this.offlineDialog = false;
          this.pageDiseaseInfoDraftList();
        });
      }
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "encyclopediaPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("encyclopediaStatus", this.contentAuditStatusList);
      sessionStorage.setItem("encyclopediaName", this.activeName);
      let selectStr = JSON.stringify(this.selectList);
      let select = JSON.stringify(this.select);
      sessionStorage.setItem("encyclopediaList", selectStr);
      sessionStorage.setItem("encyclopediaSelect", select);
      this.select.map((item) => {
        if (item.prop == "writeDoc") {
          let doctorArr = JSON.stringify(item.List);
          sessionStorage.setItem("writeDoc", doctorArr);
        }
        if (item.prop == "editorialDoctor") {
          let doctorArr = JSON.stringify(item.List);
          sessionStorage.setItem("editorialDoctor", doctorArr);
        }
      });
    },
    remarkContent(i) {
      if (i.row.statusInfo) {
        this.reasonForOffline = i.row.statusInfo.remark;
      } else {
        this.reasonForOffline = "";
      }
    },
    // 查看线上
    articlePreview(row) {
      this.jumpUrl(row.contentType, "drugs/", "", row.contentId);
    },
    jumpUrl(type, url, urlPre, urlId) {
      let urlAddress = "//beta-api.m.jd.com";
      let previewUrl1 = "https://cont-yf.jd.com/wiki/"; // 疾病症状预发地址
      let diseaseOnline = "https://cont.healthjd.com/wiki/"; // 线上疾病
      let newUrl;
      if (this.baseUrl === urlAddress) {
        // 预发
        newUrl = previewUrl1 + url + urlPre + urlId;
      } else {
        newUrl = diseaseOnline + url + urlPre + urlId;
      }
      window.open(newUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.wiki-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

.freezeDom {
  margin-top: 30px;

  .freezeInp {
    maxheight: 280px;
    max-width: 276px;
    // overflow: hidden;
    // height: 120px;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  :deep(.el-textarea__inner) {
    min-height: 145px !important;
    max-height: 280px !important;
  }

  :deep(.el-form-item__label) {
    line-height: 15px;
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

:deep(.cell) {
  font-size: 13px;
  color: rgba(93, 96, 114, 1);
  // overflow: visible !important;
}

// .tableLimit tr td .cell{
//   overflow : hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 2;      /*可以显示的行数，超出部分用...表示 */
//   -webkit-box-orient: vertical;

// }

.base-dialog {
  width: 400px;
  padding: 30px 26px 30px 26px !important;
  font-size: 14px;
  color: #2c3443;
}

.red {
  margin-left: 24px;
  // margin-top: 12px;
  position: absolute;
  color: red;
}

.rejected:hover {
  cursor: pointer;
  color: red;
}
</style>
